var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00195312,
    width: 50,
    height: 50,
    rx: 4,
    fill: "#98A2B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 21.2517V31.2517M21.875 21.2517V31.2517M28.125 21.2517V31.2517M33.75 21.2517V31.2517M13.75 33.2517L13.75 34.2517C13.75 34.9518 13.75 35.3018 13.8862 35.5692C14.0061 35.8044 14.1973 35.9956 14.4325 36.1155C14.6999 36.2517 15.0499 36.2517 15.75 36.2517H34.25C34.9501 36.2517 35.3001 36.2517 35.5675 36.1155C35.8027 35.9957 35.9939 35.8044 36.1138 35.5692C36.25 35.3018 36.25 34.9518 36.25 34.2517V33.2517C36.25 32.5517 36.25 32.2016 36.1138 31.9342C35.9939 31.699 35.8027 31.5078 35.5675 31.388C35.3001 31.2517 34.9501 31.2517 34.25 31.2517H15.75C15.0499 31.2517 14.6999 31.2517 14.4325 31.388C14.1973 31.5078 14.0061 31.699 13.8862 31.9342C13.75 32.2016 13.75 32.5517 13.75 33.2517ZM24.5661 13.8481L15.3161 15.9037C14.7573 16.0279 14.4779 16.09 14.2693 16.2402C14.0854 16.3728 13.9409 16.5529 13.8514 16.7612C13.75 16.9974 13.75 17.2836 13.75 17.8561L13.75 19.2517C13.75 19.9518 13.75 20.3018 13.8862 20.5692C14.0061 20.8044 14.1973 20.9956 14.4325 21.1155C14.6999 21.2517 15.0499 21.2517 15.75 21.2517H34.25C34.9501 21.2517 35.3001 21.2517 35.5675 21.1155C35.8027 20.9956 35.9939 20.8044 36.1138 20.5692C36.25 20.3018 36.25 19.9518 36.25 19.2517V17.8561C36.25 17.2836 36.25 16.9974 36.1486 16.7612C36.0591 16.5529 35.9146 16.3728 35.7307 16.2402C35.5221 16.09 35.2427 16.0279 34.6839 15.9037L25.4339 13.8481C25.272 13.8122 25.191 13.7942 25.1092 13.787C25.0365 13.7806 24.9635 13.7806 24.8908 13.787C24.809 13.7942 24.728 13.8122 24.5661 13.8481Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLogo);
export default __webpack_public_path__ + "static/media/BankLogo.6bcf2ecaa9f81723b6a082db3f03a850.svg";
export { ForwardRef as ReactComponent };